module.exports = __webpack_public_path__ + "static/media/arm-right-back.f3e49770.png";